<app-doc-viewer title="Activity" subtitle="Core">
  <p>Register activities in service. Use to display a loading icon</p>

  <li>
    Import <code>IgoActivityModule</code> only if you want register HTTP calls
  </li>
  <li>Import <code>IgoActivityModule</code> only once</li>

  <app-example-viewer codeFolder="core/activity">
    <div class="d-flex actions-container">
      <button mat-raised-button (click)="register()">Register</button>
      <button mat-raised-button (click)="unregister()">Unregister</button>
    </div>

    <div class="sub-content">
      <p>Counter: {{ counter }}</p>

      <igo-spinner igoSpinnerActivity />
    </div>
  </app-example-viewer>
</app-doc-viewer>
